import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import api from "@/api";

export default function LiveTicker() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/stats/live-feed").then((r) => setItems(r.data.feed || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  const doubled = [...items, ...items];
  return (
    <div data-testid="live-ticker" className="glass rounded-full overflow-hidden py-2 px-4 flex items-center gap-3">
      <div className="flex items-center gap-1 text-amber-600 shrink-0 font-semibold text-sm">
        <Sparkles size={16} /> بصمات الخير
      </div>
      <div className="overflow-hidden flex-1">
        <div className="ticker-track">
          {doubled.map((it, i) => (
            <span key={i} className="text-amber-700 text-sm mx-6 inline-flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
              {it.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
